module.exports = __webpack_public_path__ + "img/CtrlRoom_light_off.06cd2f81.png";